module.exports = __webpack_public_path__ + "static/media/arrow-left.b46e4cce.svg";